import OutstandingInvoiceBanner from '../OutstandingInvoiceBanner';
import PendingLocationsBanner from '../../pages/LocationsPage/components/PendingLocationsBanner';
import {
  selectIsEnterpriseUser,
  selectIsExAdministrator,
  selectIsLiteUser,
  selectIsProUser,
  selectUserProfile,
} from '../../selectors/user';
import { useSelector } from 'react-redux';
import { hasRoleOrHigher, isBlackFridayActive } from '../../utilities';
import MaintananceBanner from './MaintananceBanner';
import BlackFridayBanner from './BlackFridayBanner';
import SchedulingBanner from './SchedulingBanner';

const BannerRouter = () => {
  const currentUser = useSelector(selectUserProfile);
  const isEnterpriseUser = useSelector(selectIsEnterpriseUser);
  const isEXAdmin = useSelector(selectIsExAdministrator);
  const isLiteUser = useSelector(selectIsLiteUser);
  const isProUser = useSelector(selectIsProUser);

  if (!currentUser) return null;

  const isUserDomainAdminOrHigher = hasRoleOrHigher('admin', currentUser);
  const isSMBUser = !isEnterpriseUser;
  const showPendingLocationsBanner =
    currentUser?.isLocationEnabled &&
    (isSMBUser || isUserDomainAdminOrHigher) &&
    !isLiteUser;
  const showOutstandingInvoiceBanner = isSMBUser || isEXAdmin;

  return (
    <>
      {isProUser && isBlackFridayActive() && <BlackFridayBanner />}
      <MaintananceBanner />
      {!isEnterpriseUser && (
        <OutstandingInvoiceBanner enabled={showOutstandingInvoiceBanner} />
      )}
      {showPendingLocationsBanner && <PendingLocationsBanner />}
      <SchedulingBanner />
    </>
  );
};

export default BannerRouter;
